import { createContext, useContext } from "react";
import { PouchManager } from "./manager";
import { useCurrentDatabaseId, useCurrentInventoryId } from "../url";

export const DatabaseContext = createContext<PouchManager | null>(null);

export function useCurrentDatabaseManager() {
  const ctx = useContext(DatabaseContext);
  const { databaseId } = useCurrentDatabaseId();

  if (ctx === null || databaseId === undefined) {
    return undefined;
  }

  return ctx.getDatabase(databaseId);
}

export function useSetDatabaseJWT() {
  const ctx = useContext(DatabaseContext);
  return (jwt: string | null) => {
    if (ctx) {
      ctx.jwt = jwt;
    }
  };
}

/**
 * Get the PouchDB databases for the current database (based on what it says in the URL)
 */
export function useDatabases() {
  const mngr = useCurrentDatabaseManager();
  return mngr?.databases || { settings: undefined, projects: undefined, formTemplates: undefined };
}

/**
 * Get the PouchDB databases for the current inventory (based on what it says in the URL)
 */
export function useInventoryDatabases() {
  const mngr = useCurrentDatabaseManager();
  const { inventoryId } = useCurrentInventoryId();
  return inventoryId !== undefined && mngr
    ? mngr.getInventory(inventoryId)
    : { inventory: undefined, inventoryImages: undefined, inventoryThumbnails: undefined };
}
